var map = {
	"./company1.png": 12895,
	"./company10.png": 30236,
	"./company2.png": 83575,
	"./company3.png": 97991,
	"./company4.png": 49993,
	"./company5.png": 47589,
	"./company6.png": 4199,
	"./company7.png": 24069,
	"./company8.png": 11461,
	"./company9.png": 1404,
	"./drive.png": 85233,
	"./dynamics.png": 79216,
	"./highlevel.png": 30196,
	"./hubspot.png": 38179,
	"./make.png": 97789,
	"./pabbly.png": 19704,
	"./pipedrive.png": 21907,
	"./salesforce.png": 12912,
	"./sheets.png": 10378,
	"./slack.png": 75092,
	"./teams.png": 91864,
	"./zapier.png": 19598
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93445;